import axios, { AxiosRequestConfig } from "axios";
import { csrfInterceptor } from "./csrf-interceptor";

/**
 * Creates a new instance of httpClient with basic configuration
 *
 * @returns new instance of httpClient with basic configuration
 */
export const useHttpClient = () => {
    /**
     * Axios basic configuration
     * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
     * */
    const config: AxiosRequestConfig = {
        baseURL: "",
    };

    /**
     * Creating the instance of Axios
     * It is because, in large scale application we may need to consume APIs from more than single server,
     * So, may need to create multiple http client with different config
     * Only this client will be used rather than axios in the application
     **/
    const httpClient = axios.create(config);

    /** Adding the request interceptors */
    httpClient.interceptors.request.use(csrfInterceptor);

    /** Adding the response interceptors */
    httpClient.interceptors.response.use(null, (error) => {
        console.error("API ERROR", error);
        return Promise.reject(error);
    });

    return httpClient;
};
